//
// UploadErrorMessage
//
// Asset upload has limits, if we get an error we show the limits

import { observer } from 'mobx-react-lite'
import { useStore } from '../stores'

import { HView, Spacer, VView } from '../appview'
import { Bar, Button, Header, Text } from '../components'

export const UploadErrorMessage = observer(function UploadErrorMessage() {
    const store = useStore()
    const { app } = store
    return (
        <VView className="message error-message upload-error-message">
            <Header className="cc-danger">{app.text('Upload failed')}</Header>
            <Text style={{ marginBottom: 10 }}>
                {app.text(
                    'The file can be max 10MB, 25 megapixels, or 8192 pixels for width or height.'
                )}
                <br />
                {app.text('An upload can also fail if the file format is incorrect.')}
            </Text>
            <HView>
                <Spacer />
                <Bar raised>
                    <Button
                        action
                        onClick={() => store.clearMessage()}
                        style={{ paddingLeft: 15, paddingRight: 15 }}
                    >
                        {app.text('Ok')}
                    </Button>
                </Bar>
                <Spacer />
            </HView>
        </VView>
    )
})
